<script setup lang="ts">
import {computed} from "vue";
import DoseInputService from "@/dosage/services/DoseInputService";
import {Minus, Plus} from "@lucide/vue";

const dose = defineModel<number>({required: true});

const increment = () => {
    if (dose.value === 0) {
        dose.value = 1;
    } else if (dose.value < 1) {
        dose.value = Math.round((dose.value + 0.25) * 100) / 100;
    } else {
        dose.value += 1;
    }
};

const decrement = () => {
    if (dose.value > 1) {
        dose.value -= 1;
    } else if (dose.value > 0) {
        dose.value = Math.round((dose.value - 0.25) * 100) / 100;
    }
};

const label = computed(() => DoseInputService.convertToFraction(dose.value));
</script>

<template>
  <div class="flex items-center gap-1">
    <button
      class="size-5 rounded-full flex items-center justify-center transition-colors"
      :class="dose > 0 ? 'bg-primary/10 text-primary hover:bg-primary/20' : 'bg-gray-100 text-gray-300 cursor-default'"
      @click="decrement"
    >
      <Minus class="size-2.5" />
    </button>

    <span
      class="min-w-[28px] text-center text-sm font-semibold tabular-nums"
      :class="dose > 0 ? 'text-primary' : 'text-gray-300'"
    >
      {{ dose > 0 ? label : '0' }}
    </span>

    <button
      class="size-5 rounded-full bg-primary/10 text-primary hover:bg-primary/20 flex items-center justify-center transition-colors"
      @click="increment"
    >
      <Plus class="size-2.5" />
    </button>
  </div>
</template>
